import { useState } from "react";
import { toast } from "sonner";
import { Check, Pencil, Plus, Trash2, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const TypeRow = ({ t, onChanged }) => {
  const [edit, setEdit] = useState(null);
  const save = async () => {
    try { await api.put(`/documents/types/${t.id}`, { name: edit }); toast.success("Tipologia rinominata"); setEdit(null); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async () => {
    if (!window.confirm(`Eliminare la tipologia "${t.name}"?`)) return;
    try { await api.delete(`/documents/types/${t.id}`); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (edit !== null) return (
    <div className="flex items-center gap-2 px-3 py-2" data-testid={`document-type-row-${t.id}`}>
      <Input autoFocus value={edit} onChange={(e) => setEdit(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && edit.trim()) save(); if (e.key === "Escape") setEdit(null); }} className="h-8" data-testid={`document-type-edit-input-${t.id}`} />
      <Button size="sm" variant="ghost" className="text-emerald-600" onClick={save} disabled={!edit.trim()} data-testid={`document-type-save-${t.id}`}><Check className="h-4 w-4" /></Button>
      <Button size="sm" variant="ghost" className="text-slate-400" onClick={() => setEdit(null)} data-testid={`document-type-cancel-${t.id}`}><X className="h-4 w-4" /></Button>
    </div>
  );
  return (
    <div className="flex items-center justify-between px-3 py-2 text-sm" data-testid={`document-type-row-${t.id}`}>
      <span className="min-w-0 truncate">{t.name}</span>
      <div className="flex shrink-0">
        <Button size="sm" variant="ghost" className="text-slate-400" title="Rinomina" onClick={() => setEdit(t.name)} data-testid={`document-type-rename-${t.id}`}><Pencil className="h-4 w-4" /></Button>
        <Button size="sm" variant="ghost" className="text-slate-400" title="Elimina" onClick={remove} data-testid={`document-type-delete-${t.id}`}><Trash2 className="h-4 w-4" /></Button>
      </div>
    </div>
  );
};

export const TypesDialog = ({ open, types, onClose, onChanged }) => {
  const [name, setName] = useState("");
  const add = async () => {
    try { await api.post("/documents/types", { name }); setName(""); toast.success("Tipologia aggiunta"); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="document-types-dialog">
        <DialogHeader>
          <DialogTitle>Tipologie documento</DialogTitle>
          <DialogDescription>Aggiungi o rinomina le tipologie, valide per tutte le stazioni. Rinominando, si aggiornano anche i documenti già caricati.</DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <Input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && name.trim() && add()} placeholder="Nuova tipologia" data-testid="document-type-name-input" />
          <Button onClick={add} disabled={!name.trim()} data-testid="document-type-add-button"><Plus className="h-4 w-4" /></Button>
        </div>
        <div className="max-h-80 divide-y overflow-y-auto rounded-lg border">
          {types.map((t) => <TypeRow key={t.id} t={t} onChanged={onChanged} />)}
        </div>
      </DialogContent>
    </Dialog>
  );
};
